import EnhancedTable from "@apricityhealth/web-common-lib/components/EnhancedTable";
import { ImportExport } from '@apricityhealth/web-common-lib/components/ImportExport';
import Config from '@apricityhealth/web-common-lib/Config';
import TestView from './TestView';
import TestCreatorView from './TestCreatorView';
import SelectPlan from '@apricityhealth/web-common-lib/components/SelectPlan';

import React from 'react';
import {
    Drawer,
    CircularProgress,
    TextField,
    IconButton,
    Tooltip,
    Paper,
    Tabs,
    Tab,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControlLabel,
    Checkbox
} from '@material-ui/core/';

import Axios from 'axios';

import RefreshIcon from '@material-ui/icons/Refresh';
import RunTestsIcon from '@material-ui/icons/FastForward';
import ReportIcon from '@material-ui/icons/Report';
import getErrorMessage from "@apricityhealth/web-common-lib/utils/getErrorMessage";

const fileDownload = require('js-file-download');

//! Each load stage doubles the last, so 6 stages already takes 25 concurrent up to 800.
const MAX_LOAD_STAGES = 6;

function testFilter(filter, test) {
    if (filter === "" || filter === "*") return true;
    if (test) {
        filter = filter.toUpperCase();
        if (test.name && test.name.toUpperCase().indexOf(filter) >= 0)
            return true;
        if (test.description && test.description.toUpperCase().indexOf(filter) >= 0)
            return true;
        if (Array.isArray(test.tags)) {
            for (var i = 0; i < test.tags.length; ++i) {
                if (test.tags[i].indexOf(filter) >= 0)
                    return true;
            }
        }
    }
    return false;
}

export class TestsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tab: 'creators',
            modelId: '*',
            category: '*',
            creators: [],
            tests: [],
            filter: '',
            progress: null,
            report_progress: null,
            test_progress: null,
            dialog: null,
            download: null,
            upload: null,
            disableDelete: false,
            plan: props.appContext.state.plan,
            maxPermutations: 200,
            generateTestCreators: true,
            // runTests query parameters, prefilled with the server-side defaults
            // (default_run_tests_limit, load_test_stages, converse_delay_min/max)
            runLimit: 25,
            loadStages: 1,
            thinkTimeMin: 5000,
            thinkTimeMax: 10000,
            runEventTime: ''
        }
    }

    componentWillMount() {
        this.loadContent();
    }

    loadContent() {
        this.loadTests();
        this.loadTestCreators();
    }

    loadTests() {
        let { plan } = this.state
        const { appContext } = this.props;
        if (plan) {
            const getTests = {
                url: Config.baseUrl + `${Config.pathPrefix}test/${plan.planId}?errors=true&limit=0`,
                method: 'GET',
                headers: { "Authorization": appContext.state.idToken }
            }

            console.log("getTests:", getTests);
            this.setState({ progress: <CircularProgress size={20} />, error: null, testResults: '' });
            Axios(getTests).then((response) => {
                console.log("getTests response:", response);
                let tests = response.data.tests;
                this.setState({ tests, progress: null }, this.updateFilter.bind(this));
            }).catch((err) => {
                console.log("getTests error:", err);
                this.setState({ progress: null, error: getErrorMessage(err) });
            });
        }
        else {
            this.setState({ tests: [] });
        }
    }

    loadTestCreators() {
        let { plan } = this.state
        const { appContext } = this.props;
        if (plan) {
            const getTestCreators = {
                url: Config.baseUrl + `${Config.pathPrefix}test/creator/${plan.planId}/*`,
                method: 'GET',
                headers: { "Authorization": appContext.state.idToken }
            }

            console.log("getTestCreators:", getTestCreators);
            this.setState({ progress: <CircularProgress size={20} />, error: null, testResults: '' });
            Axios(getTestCreators).then((response) => {
                console.log("getTestCreators response:", response);
                let creators = response.data;
                this.setState({ creators, progress: null });
            }).catch((err) => {
                console.log("getTestCreators error:", err);
                this.setState({ progress: null, error: getErrorMessage(err) });
            });
        }
        else {
            this.setState({ creators: [] });
        }
    }

    onGeneratePermutations() {
        const { plan, category, modelId, maxPermutations, generateTestCreators } = this.state
        const { appContext } = this.props;
        if (plan) {

            const dialog = <Dialog open={true}>
                <DialogTitle>Generate Permutations</DialogTitle>
                <DialogContent>{`Please confirm you would like to generate permutations for ${plan.title}?`}
                    <br />
                    <br />
                    <TextField label='Category' style={{ width: '95%', margin: 5 }} value={category} onChange={(e) => this.setState({ category: e.target.value }, this.onGeneratePermutations.bind(this))} /><br />
                    <TextField label='Model Id' style={{ width: '95%', margin: 5 }} value={modelId} onChange={(e) => this.setState({ modelId: e.target.value }, this.onGeneratePermutations.bind(this))} /><br />
                    <TextField label='Max Permuations' style={{ margin: 5 }} type='number' value={maxPermutations} onChange={(e) => {
                        this.setState({maxPermutations: e.target.value}, this.onGeneratePermutations.bind(this) );
                    }} /><br />
                    <FormControlLabel label='Generate Test Creators' control={<Checkbox checked={generateTestCreators} onChange={(e) => this.setState({ generateTestCreators: e.target.checked}, this.onGeneratePermutations.bind(this))} />} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({dialog: null})}>Cancel</Button>
                    <Button onClick={() => {
                        const opts = {
                            async: true,
                            generateTestCreators,
                            generateTests: true         // we should always generate new tests when new permutations are generated
                        };
                        const generatePermutations = {
                            url: Config.baseUrl + `${Config.pathPrefix}test/generatePermutations?${Object.keys(opts).map((k) => `${k}=${encodeURIComponent(opts[k])}`).join('&')}`,
                            method: 'POST',
                            headers: { "Authorization": appContext.state.idToken },
                            data: {
                                planId: plan.planId,
                                maxPermutations,
                                modelId,
                                category
                            }
                        }
            
                        console.log("generatePermuations request:", generatePermutations);
                        this.setState({ progress: <CircularProgress size={20} />, error: null, dialog: null });
                        Axios(generatePermutations).then((response) => {
                            console.log("generatePermuations response:", response.data);
                            this.setState({ progress: null });
                        }).catch((err) => {
                            console.log("generatePermutations error:", err);
                            this.setState({ progress: null, error: getErrorMessage(err) });
                        });
            
                    }}>Confirm</Button>
                </DialogActions>
            </Dialog>;

            this.setState({dialog});
        }
        else {
            this.setState({ creators: [] });
        }
    }

    updateFilter() {
        let { filter, tests } = this.state;
        if (filter) {
            var filtered = [];
            for (var i = 0; i < tests.length; ++i) {
                if (testFilter(filter, tests[i]))
                    filtered.push(tests[i]);
            }
            this.setState({ filtered });
        }
        else {
            this.setState({ filtered: null });
        }
    }

    onGenerateTestReport() {
        const { appContext } = this.props;

        const recipe = 'xlsx';
        let data = {
            reportName: "TestResults",
            recipe,
        }

        const request = {
            url: Config.baseUrl + `${Config.pathPrefix}reporting/report`,
            data,
            method: 'POST',
            headers: { "Authorization": appContext.state.idToken }
        };

        this.setState({ report_progress: <CircularProgress size={20} />, error: null });

        console.log("getReport:", request);
        Axios(request).then((response) => {
            console.log("getReport response:", response);
            let report = response.data;
            report = Buffer.from(report, 'base64');
            fileDownload(report, `testresults.${recipe}`);
            this.setState({ report_progress: null, report });
        }).catch((error) => {
            console.log("getReport error:", error.response);
            this.setState({ report_progress: null, error: error.message });
        });
    }


    onCloseDialog() {
        this.setState({ dialog: null });
        this.loadContent();
        if (this._table)
            this._table.setState({ selected: [] });
        if (this._creator_table)
            this._creator_table.setState({ selected: [] });
    }

    onTestSelected(s, t) {
        const { appContext } = this.props;
        if (s.length > 0) {
            const test = this.state.filtered ? this.state.filtered[s[0]] : this.state.tests[s[0]];
            var dialog = <Drawer variant="persistent" anchor="right" open={true}>
                <TestView appContext={appContext} planId={test.planId} testId={test.testId} onClose={() => this.onCloseDialog()} />
            </Drawer>;
            this.setState({ progress: null, dialog: dialog });
        }
        else {
            // nothing selected..
            this.setState({ progress: null, dialog: null });
        }
    }

    onCreateTest() {
        const { plan } = this.state;
        const { appContext } = this.props;
        if (!plan)
            return alert("Plan must be selected first.");
        const newTest = { planId: plan.planId, testId: '', flags: [], answers: [], data: [], recommendations: [] };
        var dialog = <Drawer variant="persistent" anchor="right" open={true} >
            <TestView appContext={appContext} test={newTest} onClose={() => this.onCloseDialog()} />
        </Drawer>;
        this.setState({ progress: null, dialog: dialog });
    }

    onRunTests() {
        const { plan, runLimit, loadStages, thinkTimeMin, thinkTimeMax, disableDelete, runEventTime } = this.state;
        if (!plan)
            return alert("Plan must be selected first.");

        // re-open the dialog on every change so it shows the current values, same as onGeneratePermutations
        const update = (change) => this.setState(change, this.onRunTests.bind(this));

        // each load stage doubles the concurrency of the one before it
        let stages = [];
        for (let i = 0, concurrency = Number(runLimit); i < Number(loadStages) && i < MAX_LOAD_STAGES; ++i, concurrency *= 2)
            stages.push(concurrency);

        const badThinkTime = Number(thinkTimeMin) > Number(thinkTimeMax);
        // stages compound, so a typo here is exponentially expensive - hold it to a sane ceiling
        const badStages = !(Number(loadStages) >= 1) || Number(loadStages) > MAX_LOAD_STAGES;
        const invalid = !(Number(runLimit) >= 1) || badStages || badThinkTime;

        const dialog = <Dialog open={true} maxWidth='sm' fullWidth={true}>
            <DialogTitle>Run All Tests</DialogTitle>
            <DialogContent>{`Run every test for ${plan.title}?`}
                <br />
                <br />
                <TextField label='Concurrency' style={{ margin: 5, width: 200 }} type='number' value={runLimit}
                    helperText='Tests run in parallel per block'
                    onChange={(e) => update({ runLimit: e.target.value })} />
                <TextField label='Load Stages' style={{ margin: 5, width: 200 }} type='number' value={loadStages}
                    error={badStages}
                    helperText={badStages ? `Must be 1 to ${MAX_LOAD_STAGES}` : stages.length > 1 ? `Concurrency: ${stages.join(' → ')}` : 'Off, single run'}
                    onChange={(e) => update({ loadStages: e.target.value })} /><br />
                <TextField label='Think Time Min (ms)' style={{ margin: 5, width: 200 }} type='number' value={thinkTimeMin}
                    helperText='Simulated delay between answers'
                    onChange={(e) => update({ thinkTimeMin: e.target.value })} />
                <TextField label='Think Time Max (ms)' style={{ margin: 5, width: 200 }} type='number' value={thinkTimeMax}
                    error={badThinkTime} helperText={badThinkTime ? 'Must be at least the minimum' : 'Excluded from reported latency'}
                    onChange={(e) => update({ thinkTimeMax: e.target.value })} /><br />
                <TextField label='Event Time' style={{ margin: 5, width: 410 }} type='datetime-local'
                    InputLabelProps={{ shrink: true }} value={runEventTime}
                    helperText='Leave blank to run as of now'
                    onChange={(e) => update({ runEventTime: e.target.value })} /><br />
                <FormControlLabel label='Keep Patients' control={<Checkbox checked={disableDelete}
                    onChange={(e) => update({ disableDelete: e.target.checked })} />} />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => this.setState({ dialog: null })}>Cancel</Button>
                <Button disabled={invalid} onClick={this.runTests.bind(this)}>Run</Button>
            </DialogActions>
        </Dialog>;

        this.setState({ dialog });
    }

    runTests() {
        const { appContext } = this.props;
        const { plan, runLimit, loadStages, thinkTimeMin, thinkTimeMax, disableDelete, runEventTime } = this.state;

        // only the parameters that make sense to set by hand - the rest (offset, startTime, loadStage,
        // baseLimit, stageResults, peak, reqErrors, remainingPlans) are chain state runTests threads itself.
        const opts = { limit: runLimit, loadStages, thinkTimeMin, thinkTimeMax, disableDelete };
        if (runEventTime)
            opts.eventTime = new Date(runEventTime).toISOString();

        const runTests = {
            url: Config.baseUrl + `${Config.pathPrefix}test/run/${plan.planId}?${Object.keys(opts).map((k) => `${k}=${encodeURIComponent(opts[k])}`).join('&')}`,
            method: 'GET',
            headers: { "Authorization": appContext.state.idToken }
        }

        console.log("runTests:", runTests);
        this.setState({ test_progress: <CircularProgress size={20} />, error: null, dialog: null });
        Axios(runTests).then((response) => {
            console.log("runTests response:", response);
            this.setState({ test_progress: null, error: response.data.status }, this.loadContent(plan.planId));
        }).catch((err) => {
            console.log("runTests error:", err);
            this.setState({ test_progress: null, error: getErrorMessage(err) });
        });
    }

    onSelectTestCreator(s,t) {
        const { appContext } = this.props;
        if (s.length > 0) {
            const testCreator = t.state.data[s[0]]; //this.state.filtered ? this.state.filtered[s[0]] : this.state.tests[s[0]];
            const dialog = <Drawer variant="persistent" anchor="right" open={true}>
                <TestCreatorView appContext={appContext} testCreator={testCreator} planId={testCreator.planId} onClose={this.onCloseDialog.bind(this)} />
            </Drawer>;
            this.setState({ dialog: dialog });
        }
        else {
            // nothing selected..
            this.setState({ dialog: null });
        }

    }

    onRunCreators() {
        const { appContext } = this.props;
        const { plan: { planId } } = this.state;

        const runTestCreators = {
            url: Config.baseUrl + `${Config.pathPrefix}test/creator/run`,
            method: 'POST',
            headers: { "Authorization": appContext.state.idToken },
            data: {
                planId,
                creatorId: '*',
                modelId: '*'
            }
        };


        console.log("runTestCreators:", runTestCreators);
        this.setState({ test_progress: <CircularProgress size={20} />, error: null });
        Axios(runTestCreators).then((response) => {
            console.log("runTestCreators response:", response.data );
            this.setState({ test_progress: null });
        }).catch((err) => {
            console.log("runTestCreators error:", err);
            this.setState({ test_progress: null, error: getErrorMessage(err) });
        });

    }

    onCreateTestCreator() {
        console.log("onCreateTestCreator");
        const { plan } = this.state;
        if (!plan)
            return alert("Plan must be selected first.");
        const { appContext } = this.props;
        this.setState({ dialog: <Drawer variant="persistent" anchor="right" open={true}>
            <TestCreatorView appContext={appContext} onClose={this.onCloseDialog.bind(this)} planId={plan.planId} />
        </Drawer> });
    }

    render() {
        const { appContext } = this.props;
        const { tab, dialog, progress } = this.state;

        let tabView = null;
        if ( tab === 'tests' ) {
            let { plan } = this.state;
            const { filter, test_progress, report_progress, error,
                tests, filtered } = this.state;

            const testColumns = [
                { id: 'name', numeric: false, disabledPadding: false, label: 'Name' },
                { id: 'lastResult', numeric: false, disabledPadding: false, label: 'Last Result' },
                { id: 'jiraIssue', numeric: false, disabledPadding: false, label: 'Jira' },
                { id: 'results', numeric: true, disabledPadding: false, label: 'Results' },
                { id: 'failures', numeric: true, disabledPadding: false, label: 'Failures' },
                { id: 'errors', numeric: false, disabledPadding: false, label: 'Errors', formatValue: (v, r) => { return v > 0 ? "Yes" : "No" } },
                { id: 'case', numeric: false, disabledPadding: false, label: 'Test Case', formatValue: (v, r) => { return typeof v === 'object' ? "Yes" : "No" } },
            ];

            let testsTable = <EnhancedTable disableMultiSelect={true}
                onTable={table => this._table = table}
                onSelected={(s, t) => this.onTestSelected(s, t)}
                onAdd={() => this.onCreateTest()}
                getRowStyle={(row, index) => { return row.errors > 0 ? { 'backgroundColor': '#E57373' } : null }}
                orderBy='name'
                rowsPerPage={25}
                columnData={testColumns}
                data={filtered ? filtered : tests}
                title='Tests' />;

            let importExport = plan && <ImportExport name={'tests'}
                exportStart={() => {
                    return new Promise((resolve, reject) => {
                        let promises = [];
                        for (let i = 0; i < tests.length; ++i) {
                            const testId = tests[i].testId;
                            const getTest = {
                                url: Config.baseUrl + `${Config.pathPrefix}test/${plan.planId}/${testId}`,
                                method: 'GET',
                                headers: { "Authorization": this.props.appContext.state.idToken }
                            };

                            promises.push(Axios(getTest));
                        }

                        Promise.all(promises).then((results) => {
                            console.log("Promise results:", results);
                            let rows = [];
                            for (let i = 0; i < results.length; ++i) {
                                rows.push(results[i].data.test);
                            }

                            resolve(rows);
                        }).catch((err) => {
                            console.log("Promise error:", err);
                            reject(err);
                        });
                    })
                }}
                exportRow={(row) => {
                    delete row.__v;
                    delete row._id;
                    delete row._version;
                    delete row._index;
                    delete row.createDate;
                    delete row.updatedAt;
                    delete row.planId;
                    delete row.ownerId;
                    delete row.errors;
                }}
                importStart={() => {
                    this.setState({ progress: <CircularProgress /> });
                    const deleteTests = {
                        url: Config.baseUrl + `${Config.pathPrefix}test/${plan.planId}`,
                        method: 'DELETE',
                        headers: { "Authorization": appContext.state.idToken }
                    }
                    console.log("deleteTests:", deleteTests);
                    return Axios(deleteTests);
                }}
                importRows={(rows) => {
                    const addTest = {
                        url: Config.baseUrl + `${Config.pathPrefix}test/${plan.planId}`,
                        method: 'POST',
                        headers: { "Authorization": appContext.state.idToken },
                        data: rows
                    };

                    console.log("addTest:", addTest);
                    return Axios(addTest);
                }}
                importDone={(err) => {
                    if (err) {
                        this.setState({ progress: err.message });
                    }
                    else {
                        this.setState({ progress: null }, this.loadContent.bind(this));
                    }
                }}
            />;

            tabView = <table style={{ width: '100%' }}><tbody>
                <tr><td valign='bottom'>
                    <SelectPlan style={{ margin: 20 }} appContext={appContext}
                        allPlans={true}
                        planId={this.state.plan ? this.state.plan.planId : ''}
                        onChange={(plan) => {
                            if (plan) {
                                appContext.setState({ plan: plan })
                                this.setState({ plan: plan }, this.loadContent.bind(this));
                            }
                        }} />
                    <TextField style={{ margin: 5, width: 500 }} value={filter} label="Filter"
                        onChange={(e) => { this.setState({ filter: e.target.value }, this.updateFilter.bind(this)); }} />
                </td><td align='right'>
                        {error}
                        <Tooltip title='Refresh'><IconButton disabled={progress !== null} onClick={this.loadContent.bind(this)}>
                            {progress ? progress : <RefreshIcon />}</IconButton></Tooltip>
                        <Tooltip title='Run All Tests'><IconButton disabled={test_progress !== null} onClick={this.onRunTests.bind(this)}>
                            {test_progress ? test_progress : <RunTestsIcon />}</IconButton></Tooltip>
                        <Tooltip title='Test Report'><IconButton disabled={report_progress !== null} onClick={this.onGenerateTestReport.bind(this)}>
                            {report_progress ? report_progress : <ReportIcon />}</IconButton></Tooltip>
                        {importExport}
                    </td></tr>
                <tr><td colSpan={2}>
                    {testsTable}
                </td></tr>
            </tbody></table>;
        } else if ( tab === 'creators' ) {
            const { creators, error, test_progress } = this.state;

            const columns = [
                { id: 'creatorId', label: 'Creator ID' },
                { id: 'modelId', label: 'Model ID' },
                { id: 'detectModelId', label: 'Detect Model ID' },
                { id: 'category', label: 'Category' },
                { id: 'jiraTicket', label: 'JIRA Ticket' },
                { id: 'limit', label: 'Limit', numeric: true }
            ];

            let table = <EnhancedTable disableMultiSelect={true}
                onTable={table => this._creator_table = table}
                onSelected={this.onSelectTestCreator.bind(this)}
                onAdd={this.onCreateTestCreator.bind(this)}
                orderBy='creatorId'
                columnData={columns}
                data={creators}
                title='Test Creators' />;

            tabView = <table style={{ width: '100%' }}><tbody>
                <tr><td valign='bottom'>
                    <SelectPlan style={{ margin: 20 }} 
                        appContext={appContext}
                        planId={this.state.plan ? this.state.plan.planId : ''}
                        allPlans={true}
                        onChange={(plan) => {
                            if (plan) {
                                appContext.setState({ plan: plan })
                                this.setState({ plan: plan }, this.loadContent.bind(this));
                            }
                        }} />
                </td><td align='right'>
                        {error}
                        <Tooltip title='Refresh'><IconButton disabled={progress !== null} onClick={this.loadContent.bind(this)}>
                            {progress ? progress : <RefreshIcon />}</IconButton></Tooltip>
                        <Tooltip title='Run All Creators'><IconButton disabled={test_progress !== null} onClick={this.onRunCreators.bind(this, false)}>
                            {test_progress ? test_progress : <RunTestsIcon />}</IconButton></Tooltip>
                        <Tooltip title='Generate Permutations'><IconButton disabled={progress !== null} onClick={this.onGeneratePermutations.bind(this)}>
                            {progress ? progress : <ReportIcon />}</IconButton></Tooltip>
                    </td></tr>
                <tr><td colSpan={2}>
                    {table}
                </td></tr>
            </tbody></table>;
        }

        return <Paper square>
            <Tabs style={{ width: '100%' }} value={tab}
                variant='scrollable' scrollButtons='on'
                indicatorColor='primary' textColor='primary'
                onChange={(e,tab) => this.setState({tab})}
            >
                <Tab label='Test Creators' value='creators' />
                <Tab label='Tests' value='tests' />
            </Tabs>
            {tabView}
            {dialog}
        </Paper>;

    }
}

export default TestsView;
